import call from '../../assets/svg/call.svg';
import chat from '../../assets/svg/chat.svg';
import mail from '../../assets/svg/mail.svg';
import video from '../../assets/svg/video.svg';
import ufLogo from '../../assets/svg/uf-logo.svg';
import x from '../../assets/svg/x.svg';
import v from '../../assets/svg/v.svg';

/**
 *
 * @param {string} name - icon name
 * @returns {string} icon as SVG string
 */
export default function getSvgIcon(name) {
  switch (name.toLowerCase()) {
    case 'call':
      return call;
    case 'audio':
      return call;
    case 'chat':
      return chat;
    case 'action_mail':
    case 'mail':
      return mail;
    case 'video':
      return video;
    case 'uf-logo':
      return ufLogo;
    case 'v':
      return v;
    case 'x':
      return x;
    default:
      //instead throwing error return simple circle icon
      return '<svg viewbox="0 0 10 10"><circle cx="5" cy="5" r="5" fill="black"/></svg>';
  }
}
